import {gql, useQuery} from "@apollo/client";
import {useContext} from "react";
import {LocaleContext} from "../store/providers/LocaleProvider";

const QUERY = gql`
query getHowToGuide($locale: String!){
  howToGuideCollection(limit: 2, locale: $locale) {
      items {
        nameOfTheGuide
        indentifier
        howToStepsCollection {
          items {
            headline
            explanation
          }
        }
      }
   }
}`;

export const useHowtoGuide = () => {
    const {localeUppercase} = useContext(LocaleContext)[0];
    const {loading, data, called} = useQuery(QUERY, {variables: { locale: localeUppercase}, errorPolicy: "all"});

    const collection = data?.howToGuideCollection?.items;

    return {
        collection,
        loading,
        called
    };
};
